export default __webpack_public_path__ + "a83eb5b25bbd8600b3862ed4fad40393.svg";